import React from "react";
import { useTheme } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
import { StyleSheet, Image } from "react-native";
import { Text } from "../text/text";
import { HistoryTable } from "../data-table";
import { Stack } from "../layout/stack";
import { spacing } from "../../theme/spacing";
import automationTestingLocators from "../../screens/new/utils/automation-testing-locators.json";

export const TransactionsTable = ({
  isLoading,
  transactions = [],
  transactionsError,
  aimResidentPastError,
}: any) => {
  const theme = useTheme() as ThemeType;
  const { fontSize, colors, iconSize } = theme;
  const styles = StyleSheet.create({
    text: {
      fontSize: fontSize.large,
      color: colors.darkGrey,
      textAlign: "center",
    },
    noTransactionsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginVertical: spacing.large,
    },
    noTransactionsIcon: {
      height: iconSize.massive,
      width: iconSize.massive,
      resizeMode: "contain",
      marginBottom: spacing.smaller,
    },
  });

  // Using a component here for future network-error use case
  const NoTransactionsTable = ({ titleTx, paragraphTx, children }: any) => (
    <Stack space="small" style={styles.noTransactionsContainer}>
      {children}
      <Text
        tx={titleTx}
        style={[styles.text, { fontWeight: "bold" }]}
        {...automationTestingLocators.specificReservation.history.noTransactionsTitle}
      />
      {paragraphTx && (
        <Text
          tx={paragraphTx}
          style={styles.text}
          {...automationTestingLocators.specificReservation.history.noTransactionsBody}
        />
      )}
    </Stack>
  );

  if (transactionsError && !isLoading && !aimResidentPastError) {
    return (
      <NoTransactionsTable
        titleTx="homeStack.paymentsErrorTitle"
        paragraphTx="homeStack.paymentsErrorParagraph">
        <Image
          source={require("../../../assets/payments-error.png")}
          style={styles.noTransactionsIcon}
        />
      </NoTransactionsTable>
    );
  }

  if (!transactions.length && !isLoading && !aimResidentPastError) {
    return (
      <NoTransactionsTable
        titleTx="homeStack.noTransactionsTitle"
        paragraphTx="homeStack.noTransactionsParagraph">
        <Image
          source={require("../../../assets/empty-transactions.png")}
          style={styles.noTransactionsIcon}
        />
      </NoTransactionsTable>
    );
  }

  if (aimResidentPastError) {
    return (
      <NoTransactionsTable
        titleTx="homeStack.noLedgerTitle">
        <Image
          source={require("../../../assets/empty-transactions.png")}
          style={styles.noTransactionsIcon}
        />
      </NoTransactionsTable>
    );
  }

  return (
    <HistoryTable
      isLoading={isLoading}
      headers={["Date", "Status", "ID", "Amount"]}
      rows={transactions}
    />
  );
};
